// Chart1.js
import React from 'react'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    ArcElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js'
import { Line } from 'react-chartjs-2'

ChartJS.register(
    ArcElement,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
)

const LineChart = (props) => {
    const isVisitor = props.isVisitor

    const labelData = [
        '8:00 AM',
        '10:00 AM',
        '12:00 PM',
        '2:00 PM',
        '4:00 PM',
        '6:00 PM',
    ]

    const data = {
        labels: labelData,
        datasets: [
            {
                label: 'Dataset 1',
                data: [50, 10, 25, 65, 15, 95, 5, 100, 0],
                borderColor: '#5CB85B',
                fill: true,
                backgroundColor: '#5CB85B',
                borderWidth: 1,
                tension: 0.1,
                lineTension: 0.4,
                pointRadius: false,
            },
        ],
    }

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
            y: {
                grid: {
                    display: false,
                    drawBorder: false,
                },
            },
        },
    }

    const visitorOpt = {
        responsive: true,
        maintainAspectRatio: true,
        plugins: {
            legend: {
                display: false,
            },
        },
        scales: {
            x: {
                display: false,
            },
            y: {
                display: false,
            },
        },
    }

    return <Line options={isVisitor ? visitorOpt : options} data={data} />
}

export default LineChart
